<template>
  <div class="gold-view rank-view">
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>赛事排名</h1>
      </div>
    </div>
    <!-- <div class="tab-top">
      <div class="row">
        <div
          class="col"
          v-for="(item, index) in topTabArr"
          :key="index"
          @click="topClick(index, item.type)"
          :class="selectTopIndex === index ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
    </div>-->
    <div class="view-scroller has-header has-header-tab ranking-content" style="padding-bottom: 20px;">
      <div class="rank-box" :class="isNodata ? 'is-no-rank' : ''">
        <div class="rank-tab">
          <div
            class="tab-son"
            v-for="(item, index) in rankTabArr"
            :key="index"
            @click="rankTabClick(index, item.type)"
            :class="rankTopIndex === index ? 'tab-active' : ''"
          >{{ item.name }}</div>
        </div>
        <div class="ranking-form">
          <div class="search one-box">
            <div class="search-button"></div>
            <input class="name" type="text" v-model="i_cj_name" @blur="nameBlur()" @focus="nameIsFocus = true" placeholder="请输入产品名称或者机构名" />
            <div class="select-box top-box" v-show="showNameOptions" @click.stop>
              <cj-scroller direction="y" :noscrollbar="true">
                <div class="scroller-box">
                  <p
                    class="font-normal-color over-long"
                    v-for="option in nameOptions"
                    :key="option.value"
                    @click="selectNameOptions(option.text, option.value)"
                  >{{ option.text }}</p>
                </div>
              </cj-scroller>
            </div>
          </div>
          <div class="search select-search" v-show="userType === '1' && (rankType === '1' || rankType === '2'||rankType === '3')">
            <span class="span-title">策略组</span>
            <div class="right-box">
              <div class="cell select-cell">
                <input
                  class="select-right-box"
                  readonly="readonly"
                  type="text"
                  placeholder="请选择策略组"
                  v-model="strategyName"
                  @click="clickOrgSelect()"
                />
                <i class="ion-arrow"></i>
              </div>
              <!--下拉选择box-->
              <div class="select-box" v-show="showOrgOptions" @click.stop>
                <cj-scroller direction="y" :noscrollbar="true">
                  <div class="scroller-box">
                    <p
                      class="font-normal-color over-long"
                      v-for="option in orgOptions"
                      :key="option.value"
                      @click="selectOrgOptions(option.value)"
                    >{{ option.text }}</p>
                  </div>
                </cj-scroller>
              </div>
            </div>
          </div>
          <div class="list" :class="isNodata ? 'is-no-list' : ''">
            <div class="list-title">
              <div class="title-tab" v-show="userType === '1'">产品名称</div>
              <div class="title-tab" v-show="userType === '2'">投资者名称</div>
              <div class="title-tab" v-show="userType === '1'">管理人名称</div>
              <div class="title-tab" v-show="rankType === '3'">综合得分</div>
              <!-- <div class="title-tab" v-show="rankType === '3'">赛事总分</div> -->
              <div class="title-tab">排名</div>
            </div>
            <div class="content" v-show="!isNodata">
              <!-- loading为true时，不会触发滚动 -->
              <!-- infinite-scroll-immediate-check为true时，初始化会默认触发一次滚动 -->
              <!-- 初始化逻辑处理函数，可以忽略 -->
              <ul
                v-infinite-scroll="getMore"
                class="soll"
                infinite-scroll-disabled="loading"
                infinite-scroll-distance="20"
                infinite-scroll-immediate-check="false"
                infinite-scroll-listen-for-event="event"
              >
                <!-- v-infinite-scroll="loadMore"
                  infinite-scroll-disabled="loading"
                infinite-scroll-distance="1"-->
                <li v-for="(item, index) in rankListData" :key="index">
                  <!-- 产品名称 -->
                  <div v-show="userType === '1'">{{ item.prod_name }}</div>
                  <!-- 管理人名称 -->
                  <div v-show="userType === '1'">{{ item.prod_manager_name }}</div>
                  <!-- 专业投资者参赛名称 -->
                  <div v-show="userType === '2'">{{ item.player_name }}</div>
                  <!-- 分数 -->
                  <div v-show="rankType === '3'">{{ item.player_score }}</div>
                  <!-- 排名 -->
                  <div>{{ item.player_rank }}</div>
                </li>
              </ul>
              <div v-show="loading" style="text-align:center">正在加载...</div>
            </div>
            <div class="no-data" v-show="isNodata">
              <img src="../assets/no-data1.png" alt />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cjScroller } from 'components'
import nativeService from '../services/common/nativeService.js'
import cjServices from '../services/cjServices.js'
import { Toast } from 'mint-ui'
export default {
  components: {
    cjScroller
  },
  watch: {
    i_cj_name: {
      handler(newVal, oldVal) {
        if (this.nameIsFocus && newVal && newVal !== oldVal) {
          this.getNameList(newVal)
        } else if (this.nameIsFocus && !newVal) {
          this.showNameOptions = false
          this.cj_name = ''
          this.i_prod_record_num = ''
          this.getRankList()
        }
      }
    },
    nameIsFocus(newVal) {
      if (newVal) {
        this.showOrgOptions = false
      }
    }
  },
  data() {
    return {
      loading: false,
      arrs: [
        { prod_name: 12, prod_manager_name: 12, player_name: 123, player_score: 321, player_rank: 65 },
        { prod_name: 12, prod_manager_name: 12, player_name: 123, player_score: 321, player_rank: 65 },
        { prod_name: 12, prod_manager_name: 12, player_name: 123, player_score: 321, player_rank: 65 },
        { prod_name: 12, prod_manager_name: 12, player_name: 123, player_score: 321, player_rank: 65 }
      ],
      // 当前页
      i_page: 1,
      //每页行数
      i_perpage: 100,
      isSpecial: false, // true: 专业投资者， false:私募产品组
      topTabArr: [
        { name: '私募产品组', index: 0, type: '1' },
        { name: '专业投资者组', index: 1, type: '2' }
      ],
      rankTabArr: [
        { name: '月排名', index: 0, type: '2' },
        { name: '总排名', index: 1, type: '3' }
      ],
      // 策略组
      orgOptions: [
        { text: '量化股票策略组', value: '1' },
        { text: '主观股票策略组', value: '2' },
        { text: '混合策略组', value: '5' },
        { text: '主观CTA策略组', value: '6' },
        { text: '量化对冲策略组', value: '7' },
        { text: '量化CTA策略组', value: '8' }
      ],
      // 模糊搜索输入的数据
      nameOptions: [],
      // 1 私募 2 专业
      userType: '1',
      //  1-周排名，2-月排名，3-总排名
      rankType: '2',
      selectTopIndex: 0,
      rankTopIndex: 0,
      strategyName: '量化股票策略组',
      // 策略组的默认值
      i_prod_strategy: '1',
      // 策略组是否展示 下拉
      showOrgOptions: false,
      // 是否输入名称
      showNameOptions: false,
      // 搜索的名称
      i_cj_name: '',
      // 编号
      i_prod_record_num: '',
      // 排名列表数据
      rankListData: [],
      nameIsFocus: false,
      // 是否有数据
      isNodata: false
    }
  },
  methods: {
    // 滚动效果
    getMore() {
      this.loading = true //事先关闭防止重复触发
      setTimeout(() => {
        // ...逻辑处理
        this.i_page += 1
        // this.rankListData.push(...this.arrs);
        this.loading = false //再开启
        // console.log('this.rankListData', this.rankListData);
        this.getRankList()
      }, 1000)
      // console.log('111', 111);
    },
    //  头部点击
    topClick(index, type) {
      if (this.selectTopIndex !== index) {
        this.selectTopIndex = index
        this.userType = type
        // this.rankTopIndex = 0
        // this.rankType = '1'
        this.cj_name = ''
        // 修改下拉框的默认值
        this.i_prod_strategy = '1'
        this.strategyName = '量化股票策略组'
        this.i_cj_name = ''
        console.log(this.i_prod_strategy)
        this.getRankList()
      }
    },
    // 排名点击
    rankTabClick(index, type) {
      if (this.rankTopIndex !== index) {
        this.rankTopIndex = index
        this.rankType = type
        // this.i_cj_name = ''
        // 修改下拉框的默认值
        this.i_prod_strategy = '1'
        this.strategyName = '量化股票策略组'
        console.log(this.i_prod_strategy)
        this.getRankList()
      }
    },
    // 名称搜索失去光标
    nameBlur() {
      this.nameIsFocus = false
      setTimeout(() => {
        this.showNameOptions = false
      }, 100)
    },
    // 输入名称后选择
    selectNameOptions(text, value) {
      this.showNameOptions = false
      this.i_cj_name = text
      this.i_prod_record_num = value
      console.log(this.i_prod_record_num)
      this.getRankList()
    },
    // 点击策略组input
    clickOrgSelect() {
      this.showOrgOptions = !this.showOrgOptions
      //  console.log(this.selectOrgOptions,23);
    },
    // 选择下拉
    selectOrgOptions(value) {
      console.log(value)
      this.showOrgOptions = false
      this.orgOptions.forEach(l => {
        if (l.value == value) {
          this.strategyName = l.text
        }
      })
      this.i_prod_strategy = value
      this.getRankList()
    },
    // 获取排名数据
    getRankList() {
      // console.log('this.rankListData', this.rankListData)
      this.rankListData = []
      const data = {
        i_prod_record_num: this.i_prod_record_num,
        i_user_type: this.userType,
        i_type: this.rankType,
        i_cj_name: this.i_cj_name,
        i_prod_strategy: this.i_prod_strategy,
        i_page: this.i_page,
        i_perpage: this.i_perpage
      }
      cjServices.rankList(this, data).then(res => {
        if (res.body && res.body.error_code == '0') {
          if (res.body.results) {
            if (res.body.results.length > 0 || this.rankListData.length > 0) {
              this.isNodata = false
              this.rankListData.push(...res.body.results)
              // this.rankListData.push(this.rankListData)
            } else {
              this.isNodata = true
            }
          }
        } else {
          this.isNodata = true
          Toast({
            message: res.body.error_info,
            duration: 2000
          })
        }
      })
    },
    // 模糊搜索数据
    getNameList(name) {
      // i_user_type：1-私募 2-专业投资者
      //  i_name：搜索名称
      this.showNameOptions = false
      const data = {
        i_user_type: this.userType,
        i_name: name.trim()
      }
      cjServices.selectNameList(this, data).then(res => {
        if (res.body && res.body.error_code == '0') {
          let results = res.body.results
          if (results.length > 0) {
            this.showNameOptions = true
            this.nameOptions = results.map(l => {
              return {
                text: l.cj_name,
                value: l.prod_record_num
              }
            })
          }
        }
      })
    },
    // 无限滚动
    // loadMore() {
    //   this.loading = false;
    //   setTimeout(() => {
    //     let last = this.list[this.list.length - 1];
    //     for (let i = 1; i <= 10; i++) {
    //       this.list.push(last + i);
    //     }
    //     this.loading = false;
    //   }, 2500);
    // },
    // 返回
    goBack() {
      nativeService.routerRedirect(-1, this)
    },
    isCjehApp() {
      if (navigator.userAgent.indexOf('cjsccjeh') > -1) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getRankList()
  }
}
</script>

<style lang="scss" scoped>
@import 'sass/gold/common.scss';
@import 'sass/gold/ranking.scss';
</style>
